<template>
  <span>
    <CdnImg
      v-if="image && (image.mobile || image.desktop)"
      :src="handleImageSrc((isMobile && image.mobile) || image.desktop)"
      :alt="handleImageAlt((isMobile && image.mobile) || image.desktop)"
      class="absolute inset-0 h-full w-full object-scale-down transition duration-500 ease-out group-hover:scale-110 md:object-contain"
      loading="lazy"
    />

    <template v-else-if="images">
      <template v-if="isMobile">
        <span
          v-if="images.mobile"
          v-lazy-background="getImage(images.mobile)"
          :style="getStyles('mobile')"
          class="absolute inset-0 bg-bottom bg-no-repeat sm:bg-cover"
        ></span>
      </template>

      <template v-else>
        <span
          v-for="type in desktopImageTypes"
          :key="type"
          v-lazy-background="getImage(images[type])"
          :style="getStyles(type, isHover)"
          class="absolute inset-0 transform-gpu bg-cover bg-center bg-no-repeat transition-all duration-500"
        ></span>
      </template>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  image?: any;
  images?: any;
  styles?: any;
  isMobile?: boolean;
  isHover?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  image: () => ({}),
  images: () => ({}),
  styles: () => ({}),
  isMobile: false,
  isHover: false,
});

const { getAssetUrl } = useMediaAsset();

const desktopImageTypes = computed(() =>
  ['primary', 'secondary'].filter((type) => props.images?.[type]),
);

const getImage = (image: string | object) => getAssetUrl(handleImageSrc(image));

const getStyles = (type: string, hover: boolean = false) =>
  props.styles?.[hover ? 'hover' : 'base']?.[type] ?? {};
</script>
